import { render, staticRenderFns } from "./ProductCost3.vue?vue&type=template&id=39a01924&scoped=true"
import script from "./ProductCost3.vue?vue&type=script&lang=js"
export * from "./ProductCost3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a01924",
  null
  
)

export default component.exports